export default __webpack_public_path__ + "static/STATUTO_MOVE_ART_SSD-d4becee42413d29961e6b327cfe9a74e.pdf";